import {root} from '../config';
import vue from 'vue';

function url(api) {
  return root + '/carousel/' + api;
}

/**
 * 获取轮播图
 * @param type 轮播位置
 * @return {*}
 */
export function api_getData(type) {
  return vue.http({
    method: 'get',
    url: url('getData'),
    params: {
      type: type
    }
  });
}
